import styled from 'styled-components'

export const PageStyle = styled.div`
  height: calc(100% - 56px);
`
